
<div>
    <div class="crm-button-bar primary">
        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <a
                    @click = "onCancel"
                    v-bind = "attrs"
                    v-on   = "on"
                >
                    <v-icon color="white" left>fa fa-times</v-icon>
                </a>
            </template>
            <span>{{ $t('crm.menu.cancel') }}</span>
        </v-tooltip>

        <v-spacer />

        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <a
                    @click = "onSave"
                    v-bind = "attrs"
                    v-on   = "on"
                >
                    <v-icon color="white" >fa fa-save</v-icon>
                </a>
            </template>
            <span>{{ $t('crm.menu.save') }}</span>
        </v-tooltip>
    </div>

    <crm-entry-edit
        :entry    = "entry"
        :incident = "incident"
        class     = "mb-1"
        ref       = "editor"
        @saved    = "onSaved"
    />
</div>
